import SectionHeading from "./SectionHeading";

export default function ItemReviewStep({
  items,
  itemChecked,
  discountRate,
  taxRate,
  subtotals,
  handleItemCheck,
  handleDiscountChange,
  handleTaxChange,
  rowInput,
  money,
}) {
  return (
    <div>
      <SectionHeading hint="Uncheck any items you don't want to include in this order.">Item Details</SectionHeading>
      <div className="space-y-3">
        {items.map((item, index) => {
          const checked = !!itemChecked[index];
          return (
            <div
              key={item.id}
              className={`rounded-xl border p-3 transition-colors sm:p-3.5 ${
                checked ? "border-brand-200 bg-brand-50/30" : "border-slate-200 bg-slate-50/40"
              }`}
            >
              <label className="mb-3 flex items-start justify-between gap-2">
                <span className="flex items-start gap-2">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => handleItemCheck(index, e.target.checked)}
                    className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-brand-600 focus:ring-brand-500/30"
                  />
                  <span className="text-[13px] font-semibold text-slate-800">{item.item}</span>
                </span>
                <span className="shrink-0 rounded-md bg-white px-2 py-1 text-right text-[12px] font-semibold text-slate-800 ring-1 ring-slate-200">
                  {money(subtotals[index])}
                </span>
              </label>

              <div className="grid grid-cols-2 gap-x-3 gap-y-2.5 pl-6 text-[12px] sm:grid-cols-4">
                <div className="min-w-0">
                  <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Manufacturer</p>
                  <p className="truncate text-slate-700">{item.manufacturer}</p>
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Catalog</p>
                  <p className="truncate text-slate-700">{item.catalog}</p>
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400"># Units</p>
                  <p className="text-slate-700">{item.numUnits}</p>
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Unit Price</p>
                  <p className="text-slate-700">₹{item.unitPrice}</p>
                </div>
                <div className="min-w-0">
                  <p className="mb-1 text-[10px] font-medium uppercase tracking-wide text-slate-400">Discount %</p>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={(discountRate[index] || 0) * 100}
                    onChange={(e) => handleDiscountChange(index, e.target.value)}
                    className={rowInput}
                  />
                </div>
                <div className="min-w-0">
                  <p className="mb-1 text-[10px] font-medium uppercase tracking-wide text-slate-400">Tax %</p>
                  <input
                    type="number"
                    min={0}
                    value={(taxRate[index] || 0) * 100}
                    onChange={(e) => handleTaxChange(index, e.target.value)}
                    className={rowInput}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}